import {DatoImage} from '~/cms/components/DatoImage'
import {getLinkProps} from '~/cms/components/LinkComponent'
import {SingleLineStructuredText} from '~/cms/components/SingleLineStructuredText'
import {wysiwygComponentVariants} from '~/cms/components/WYSIWYG/_utils/variants'
import {
  HgArticlePromoProduct as HgArticleWYSIWYGPromoProduct,
  type HgArticlePromoProductProps,
} from '~/design-system/hg/components'
import {type ArticleWysiwygProductPromoFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGArticlePromoProductProps = ArticleWysiwygProductPromoFragment

export const DatoWYSIWYGProductPromo = ({
  heading,
  body,
  promoLink,
  sixteenNineAsset,
}: DatoWYSIWYGArticlePromoProductProps) => {
  const {promo} = wysiwygComponentVariants()

  return (
    <HgArticleWYSIWYGPromoProduct
      heading={<SingleLineStructuredText data={heading} />}
      body={body && <SingleLineStructuredText data={body} />}
      promoLink={{
        type: promoLink.linkType as HgArticlePromoProductProps['promoLink']['type'],
        linkProps: getLinkProps(
          promoLink.linkProps
        ) as HgArticlePromoProductProps['promoLink']['linkProps'],
      }}
      sixteenNineAsset={<DatoImage data={sixteenNineAsset} />}
      className={promo()}
    />
  )
}
